import { type GetServerSideProps } from 'next';

import { getFaqHomeData } from '../../modules/faq';

import { withEnhancedPageHandler } from '../../middlewares/withEnhancedPageHandler';

import { applyCorrelationIdHeader } from '../../utils/server/applyCorrelationIdHeader';

import { FaqHomeTemplate } from '../../templates';

import { type IFaqHomeProps } from '../../modules/faq/pageProps/getFaqHomePageProps/@interfaces';
import { type TLocale } from '../../modules/shared/@interfaces';

const FaqHome = (props: IFaqHomeProps) => <FaqHomeTemplate {...props} />;

const getServerSidePropsHandler: GetServerSideProps = async ({
  locale: localeRaw,
  req,
}) => {
  const customHeaders = applyCorrelationIdHeader(req.headers);
  const locale = localeRaw as TLocale;

  const props = await getFaqHomeData({ locale, customHeaders });

  return {
    props,
  };
};

export const getServerSideProps = withEnhancedPageHandler(
  getServerSidePropsHandler
);

export default FaqHome;
